"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLikelyStreetAddressUnit = exports.STREET_ADDRESS_COMPONENT_NORMALIZATION_GROUPS = void 0;
/*
    all lower case
    maps list of strings to a specific shortened string
    edit this first one, use the second, generated one
    based on: https://pe.usps.com/text/pub28/28apc_002.htm
    generated using an excel file stored on drive here: https://docs.google.com/spreadsheets/d/1XrR0ZLUNAKvPrlkK3TV0i_-a-mCvjolg/edit#gid=1837496146
    ported to python in aven_python/src/utils/streetAddressMatcher.py - please keep the two in sync
 */
exports.STREET_ADDRESS_COMPONENT_NORMALIZATION_GROUPS = [
    [['ALLEE', 'ALLEY', 'ALLY', 'ALY'], 'ALY'],
    [['ANEX', 'ANNEX', 'ANNX', 'ANX'], 'ANX'],
    [['ARC', 'ARCADE'], 'ARC'],
    [['AV', 'AVE', 'AVEN', 'AVENU', 'AVENUE', 'AVN', 'AVNUE'], 'AVE'],
    [['BAYOO', 'BAYOU'], 'BYU'],
    [['BCH', 'BEACH'], 'BCH'],
    [['BEND', 'BND'], 'BND'],
    [['BLF', 'BLUF', 'BLUFF'], 'BLF'],
    [['BLUFFS'], 'BLFS'],
    [['BOT', 'BTM', 'BOTTM', 'BOTTOM'], 'BTM'],
    [['BLVD', 'BOUL', 'BOULEVARD', 'BOULV'], 'BLVD'],
    [['BR', 'BRNCH', 'BRANCH'], 'BR'],
    [['BRDGE', 'BRG', 'BRIDGE'], 'BRG'],
    [['BRK', 'BROOK'], 'BRK'],
    [['BROOKS'], 'BRKS'],
    [['BURG'], 'BG'],
    [['BURGS'], 'BGS'],
    [['BYP', 'BYPA', 'BYPAS', 'BYPASS', 'BYPS'], 'BYP'],
    [['CAMP', 'CP', 'CMP'], 'CP'],
    [['CANYN', 'CANYON', 'CNYN'], 'CYN'],
    [['CAPE', 'CPE'], 'CPE'],
    [['CAUSEWAY', 'CAUSWA', 'CSWY'], 'CSWY'],
    [['CEN', 'CENT', 'CENTER', 'CENTR', 'CENTRE', 'CNTER', 'CNTR', 'CTR'], 'CTR'],
    [['CENTERS'], 'CTRS'],
    [['CIR', 'CIRC', 'CIRCL', 'CIRCLE', 'CRCL', 'CRCLE'], 'CIR'],
    [['CIRCLES'], 'CIRS'],
    [['CLF', 'CLIFF'], 'CLF'],
    [['CLFS', 'CLIFFS'], 'CLFS'],
    [['CLB', 'CLUB'], 'CLB'],
    [['COMMON'], 'CMN'],
    [['COMMONS'], 'CMNS'],
    [['COR', 'CORNER'], 'COR'],
    [['CORNERS', 'CORS'], 'CORS'],
    [['COURSE', 'CRSE'], 'CRSE'],
    [['COURT', 'CT'], 'CT'],
    [['COURTS', 'CTS'], 'CTS'],
    [['COVE', 'CV'], 'CV'],
    [['COVES'], 'CVS'],
    [['CREEK', 'CRK'], 'CRK'],
    [['CRESCENT', 'CRES', 'CRSENT', 'CRSNT'], 'CRES'],
    [['CREST'], 'CRST'],
    [['CROSSING', 'CRSSNG', 'XING'], 'XING'],
    [['CROSSROAD'], 'XRD'],
    [['CROSSROADS'], 'XRDS'],
    [['CURVE'], 'CURV'],
    [['DALE', 'DL'], 'DL'],
    [['DAM', 'DM'], 'DM'],
    [['DIV', 'DIVIDE', 'DV', 'DVD'], 'DV'],
    [['DR', 'DRIV', 'DRIVE', 'DRV'], 'DR'],
    [['DRIVES'], 'DRS'],
    [['EAST', 'E'], 'E'],
    [['EST', 'ESTATE'], 'EST'],
    [['ESTATES', 'ESTS'], 'ESTS'],
    [['EXP', 'EXPR', 'EXPRESS', 'EXPRESSWAY', 'EXPW', 'EXPY'], 'EXPY'],
    [['EXT', 'EXTENSION', 'EXTN', 'EXTNSN'], 'EXT'],
    [['EXTS'], 'EXTS'],
    [['FALL'], 'FALL'],
    [['FALLS', 'FLS'], 'FLS'],
    [['FERRY', 'FRRY', 'FRY'], 'FRY'],
    [['FIELD', 'FLD'], 'FLD'],
    [['FIELDS', 'FLDS'], 'FLDS'],
    [['FLAT', 'FLT'], 'FLT'],
    [['FLATS', 'FLTS'], 'FLTS'],
    [['FORD', 'FRD'], 'FRD'],
    [['FORDS'], 'FRDS'],
    [['FOREST', 'FORESTS', 'FRST'], 'FRST'],
    [['FORG', 'FORGE', 'FRG'], 'FRG'],
    [['FORGES'], 'FRGS'],
    [['FORK', 'FRK'], 'FRK'],
    [['FORKS', 'FRKS'], 'FRKS'],
    [['FORT', 'FRT', 'FT'], 'FT'],
    [['FREEWAY', 'FREEWY', 'FRWAY', 'FRWY', 'FWY'], 'FWY'],
    [['GARDEN', 'GARDN', 'GRDEN', 'GRDN'], 'GDN'],
    [['GARDENS', 'GDNS', 'GRDNS'], 'GDNS'],
    [['GATEWAY', 'GATEWY', 'GATWAY', 'GTWAY', 'GTWY'], 'GTWY'],
    [['GLEN', 'GLN'], 'GLN'],
    [['GLENS'], 'GLNS'],
    [['GREEN', 'GRN'], 'GRN'],
    [['GREENS'], 'GRNS'],
    [['GROV', 'GROVE', 'GRV'], 'GRV'],
    [['GROVES'], 'GRVS'],
    [['HARB', 'HARBOR', 'HARBR', 'HBR', 'HRBOR'], 'HBR'],
    [['HARBORS'], 'HBRS'],
    [['HAVEN', 'HVN'], 'HVN'],
    [['HT', 'HTS'], 'HTS'],
    [['HIGHWAY', 'HIGHWY', 'HIWAY', 'HIWY', 'HWAY', 'HWY'], 'HWY'],
    [['HILL', 'HL'], 'HL'],
    [['HILLS', 'HLS'], 'HLS'],
    [['HLLW', 'HOLLOW', 'HOLLOWS', 'HOLW', 'HOLWS'], 'HOLW'],
    [['INLT'], 'INLT'],
    [['IS', 'ISLAND', 'ISLND'], 'IS'],
    [['ISLANDS', 'ISLNDS', 'ISS'], 'ISS'],
    [['ISLE', 'ISLES'], 'ISLE'],
    [['JCT', 'JCTION', 'JCTN', 'JUNCTION', 'JUNCTN', 'JUNCTON'], 'JCT'],
    [['JCTNS', 'JCTS', 'JUNCTIONS'], 'JCTS'],
    [['KEY', 'KY'], 'KY'],
    [['KEYS', 'KYS'], 'KYS'],
    [['KNL', 'KNOL', 'KNOLL'], 'KNL'],
    [['KNLS', 'KNOLLS'], 'KNLS'],
    [['LK', 'LAKE'], 'LK'],
    [['LKS', 'LAKES'], 'LKS'],
    [['LAND'], 'LAND'],
    [['LANDING', 'LNDG', 'LNDNG'], 'LNDG'],
    [['LANE', 'LN'], 'LN'],
    [['LGT', 'LIGHT'], 'LGT'],
    [['LIGHTS'], 'LGTS'],
    [['LF', 'LOAF'], 'LF'],
    [['LCK', 'LOCK'], 'LCK'],
    [['LCKS', 'LOCKS'], 'LCKS'],
    [['LDG', 'LDGE', 'LODG', 'LODGE'], 'LDG'],
    [['LOOP', 'LOOPS'], 'LOOP'],
    [['MALL'], 'MALL'],
    [['MNR', 'MANOR'], 'MNR'],
    [['MANORS', 'MNRS'], 'MNRS'],
    [['MEADOW'], 'MDW'],
    [['MDW', 'MDWS', 'MEADOWS', 'MEDOWS'], 'MDWS'],
    [['MEWS'], 'MEWS'],
    [['MILL'], 'ML'],
    [['MILLS'], 'MLS'],
    [['MISSN', 'MSSN'], 'MSN'],
    [['MOTORWAY'], 'MTWY'],
    [['MNT', 'MT', 'MOUNT'], 'MT'],
    [['MNTAIN', 'MNTN', 'MOUNTAIN', 'MOUNTIN', 'MTIN', 'MTN'], 'MTN'],
    [['MNTNS', 'MOUNTAINS'], 'MTNS'],
    [['NCK', 'NECK'], 'NCK'],
    [['NORTH', 'N'], 'N'],
    [['NORTHEAST', 'NE'], 'NE'],
    [['NORTHWEST', 'NW'], 'NW'],
    [['ORCH', 'ORCHARD', 'ORCHRD'], 'ORCH'],
    [['OVAL', 'OVL'], 'OVAL'],
    [['OVERPASS'], 'OPAS'],
    [['PARK', 'PRK'], 'PARK'],
    [['PARKS'], 'PARK'],
    [['PARKWAY', 'PARKWY', 'PKWAY', 'PKWY', 'PKY'], 'PKWY'],
    [['PARKWAYS', 'PKWYS'], 'PKWY'],
    [['PASS'], 'PASS'],
    [['PASSAGE'], 'PSGE'],
    [['PATH', 'PATHS'], 'PATH'],
    [['PIKE', 'PIKES'], 'PIKE'],
    [['PINE'], 'PNE'],
    [['PINES', 'PNES'], 'PNES'],
    [['PL'], 'PL'],
    [['PLAIN', 'PLN'], 'PLN'],
    [['PLAINS', 'PLNS'], 'PLNS'],
    [['PLAZA', 'PLZ', 'PLZA'], 'PLZ'],
    [['POINT', 'PT'], 'PT'],
    [['POINTS', 'PTS'], 'PTS'],
    [['PORT', 'PRT'], 'PRT'],
    [['PORTS', 'PRTS'], 'PRTS'],
    [['PR', 'PRAIRIE', 'PRR'], 'PR'],
    [['RAD', 'RADIAL', 'RADIEL', 'RADL'], 'RADL'],
    [['RAMP'], 'RAMP'],
    [['RANCH', 'RANCHES', 'RNCH', 'RNCHS'], 'RNCH'],
    [['RAPID', 'RPD'], 'RPD'],
    [['RAPIDS', 'RPDS'], 'RPDS'],
    [['REST', 'RST'], 'RST'],
    [['RDG', 'RDGE', 'RIDGE'], 'RDG'],
    [['RDGS', 'RIDGES'], 'RDGS'],
    [['RIV', 'RIVER', 'RVR', 'RIVR'], 'RIV'],
    [['RD', 'ROAD'], 'RD'],
    [['ROADS', 'RDS'], 'RDS'],
    [['ROUTE'], 'RTE'],
    [['ROW'], 'ROW'],
    [['RUE'], 'RUE'],
    [['RUN'], 'RUN'],
    [['SHL', 'SHOAL'], 'SHL'],
    [['SHLS', 'SHOALS'], 'SHLS'],
    [['SHOAR', 'SHORE', 'SHR'], 'SHR'],
    [['SHOARS', 'SHORES', 'SHRS'], 'SHRS'],
    [['SKYWAY'], 'SKWY'],
    [['SPG', 'SPNG', 'SPRING', 'SPRNG'], 'SPG'],
    [['SPGS', 'SPNGS', 'SPRINGS', 'SPRNGS'], 'SPGS'],
    [['SPUR'], 'SPUR'],
    [['SPURS'], 'SPUR'],
    [['SQ', 'SQR', 'SQRE', 'SQU', 'SQUARE'], 'SQ'],
    [['SQRS', 'SQUARES'], 'SQS'],
    [['STA', 'STATION', 'STATN', 'STN'], 'STA'],
    [['STRA', 'STRAV', 'STRAVEN', 'STRAVENUE', 'STRAVN', 'STRVN', 'STRVNUE'], 'STRA'],
    [['STREAM', 'STREME', 'STRM'], 'STRM'],
    [['STREET', 'STRT', 'ST', 'STR'], 'ST'],
    [['STREETS'], 'STS'],
    [['SMT', 'SUMIT', 'SUMITT', 'SUMMIT'], 'SMT'],
    [['SOUTH', 'S'], 'S'],
    [['SOUTHEAST', 'SE'], 'SE'],
    [['SOUTHWEST', 'SW'], 'SW'],
    [['TER', 'TERR', 'TERRACE'], 'TER'],
    [['THROUGHWAY'], 'TRWY'],
    [['TRACE', 'TRACES', 'TRCE'], 'TRCE'],
    [['TRACK', 'TRACKS', 'TRAK', 'TRK', 'TRKS'], 'TRAK'],
    [['TRAFFICWAY'], 'TRFY'],
    [['TRAIL', 'TRAILS', 'TRL', 'TRLS'], 'TRL'],
    [['TRAILER', 'TRLR', 'TRLRS'], 'TRLR'],
    [['TUNEL', 'TUNL', 'TUNLS', 'TUNNEL', 'TUNNELS', 'TUNNL'], 'TUNL'],
    [['TRNPK', 'TURNPIKE', 'TURNPK'], 'TPKE'],
    [['UNDERPASS'], 'UPAS'],
    [['UN', 'UNION'], 'UN'],
    [['UNIONS'], 'UNS'],
    [['VALLEY', 'VALLY', 'VLLY', 'VLY'], 'VLY'],
    [['VALLEYS', 'VLYS'], 'VLYS'],
    [['VDCT', 'VIA', 'VIADCT', 'VIADUCT'], 'VIA'],
    [['VIEW', 'VW'], 'VW'],
    [['VIEWS', 'VWS'], 'VWS'],
    [['VILL', 'VILLAG', 'VILLAGE', 'VILLG', 'VILLIAGE', 'VLG'], 'VLG'],
    [['VILLAGES', 'VLGS'], 'VLGS'],
    [['VILLE', 'VL'], 'VL'],
    [['VIS', 'VIST', 'VISTA', 'VST', 'VSTA'], 'VIS'],
    [['WALK'], 'WALK'],
    [['WALKS'], 'WALK'],
    [['WALL'], 'WALL'],
    [['WEST', 'W'], 'W'],
    [['WY', 'WAY'], 'WAY'],
    [['WAYS'], 'WAYS'],
    [['WELL'], 'WL'],
    [['WELLS', 'WLS'], 'WLS'],
];
const CARDINAL_DIRECTIONS = new Set(['NORTH', 'N', 'NORTHEAST', 'NE', 'EAST', 'E', 'SOUTHEAST', 'SE', 'SOUTH', 'S', 'SOUTHWEST', 'SW', 'WEST', 'W', 'NORTHWEST', 'NW']);
const STREET_SUFFIXES = new Set(exports.STREET_ADDRESS_COMPONENT_NORMALIZATION_GROUPS.flatMap(([possibleKeys]) => possibleKeys).filter((possibleKey) => !CARDINAL_DIRECTIONS.has(possibleKey)));
const isLikelyStreetAddressUnit = (unit) => {
    const tokens = (unit ?? '').trim().toUpperCase().replace(/[.,]/g, '').split(/\s+/).filter(Boolean);
    if (tokens.length < 2) {
        return false;
    }
    const lastToken = tokens[tokens.length - 1];
    if (STREET_SUFFIXES.has(lastToken)) {
        return true;
    }
    const secondToLastToken = tokens[tokens.length - 2];
    return tokens.length >= 3 && CARDINAL_DIRECTIONS.has(lastToken) && STREET_SUFFIXES.has(secondToLastToken);
};
exports.isLikelyStreetAddressUnit = isLikelyStreetAddressUnit;
